if (!customElements.get('back-in-stock-notification')) {
  customElements.define(
    'back-in-stock-notification',
    class BackInStockNotification extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.back-in-stock-notification__trigger');
        this.panel = this.querySelector('.back-in-stock-notification__panel');
        this.form = this.querySelector('form');
        this.errorMessage = this.querySelector('.back-in-stock-notification__error');

        this.trigger?.addEventListener('click', this.openPanel.bind(this));
        this.form?.addEventListener('submit', this.onSubmit.bind(this));

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, variant } }) => {
          if (this.dataset.section !== sectionId) return;
          this.onVariantChange(variant);
        });

        // Watch for the "unavailable combination" case where setUnavailable() runs
        // but no variantChange event is published.
        const submitButton = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        if (submitButton) {
          this.submitButtonRef = submitButton;
          this.mutationObserver = new MutationObserver(() => {
            clearTimeout(this.syncTimeout);
            this.syncTimeout = setTimeout(() => this.syncFromButton(), 0);
          });
          this.mutationObserver.observe(submitButton, { attributes: true, attributeFilter: ['disabled'] });
        }
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
        this.mutationObserver?.disconnect();
      }

      openPanel() {
        this.trigger.classList.add('hidden');
        this.panel.classList.remove('hidden');
        this.querySelector('[type="email"]')?.focus();
      }

      onVariantChange(variant) {
        const isSoldOut = !variant.available;
        this.toggle(isSoldOut);
        if (isSoldOut) this.updateBodyInput(variant);
        this.reset();
      }

      syncFromButton() {
        if (!this.submitButtonRef) return;
        const isDisabled = this.submitButtonRef.hasAttribute('disabled');
        const buttonText = this.submitButtonRef.querySelector('span')?.textContent?.trim();
        const isSoldOut = isDisabled && buttonText === window.variantStrings?.soldOut;
        const isUnavailable = isDisabled && buttonText === window.variantStrings?.unavailable;

        if (isUnavailable) {
          this.toggle(false);
          this.reset();
        } else if (isSoldOut) {
          this.toggle(true);
        }
      }

      toggle(show) {
        this.classList.toggle('hidden', !show);
        if (!show) this.reset();
      }

      updateBodyInput(variant) {
        const bodyInput = this.querySelector('[name="contact[body]"]');
        if (!bodyInput) return;
        bodyInput.value = `Back in stock request: ${document.title} — ${variant.title} (Variant ID: ${variant.id}) — ${window.location.href}`;
      }

      reset() {
        this.trigger?.classList.remove('hidden');
        this.panel?.classList.add('hidden');
        const emailInput = this.querySelector('[type="email"]');
        if (emailInput) emailInput.value = '';
        this.errorMessage?.classList.add('hidden');
        const submitBtn = this.querySelector('[type="submit"]');
        if (submitBtn) {
          submitBtn.textContent = window.backInStockStrings?.submit || 'Notify me';
          submitBtn.removeAttribute('disabled');
        }
      }

      onSubmit(event) {
        event.preventDefault();

        const emailInput = this.querySelector('[type="email"]');
        if (!emailInput?.checkValidity()) {
          emailInput?.reportValidity();
          return;
        }

        const submitBtn = this.querySelector('[type="submit"]');
        submitBtn?.setAttribute('disabled', '');
        this.errorMessage?.classList.add('hidden');

        fetch('/contact', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: new URLSearchParams(new FormData(this.form)),
        })
          .then(() => {
            // Change the button text to show success — leave it disabled
            if (submitBtn) {
              submitBtn.textContent = window.backInStockStrings?.success || 'Done!';
            }
            emailInput.value = '';
          })
          .catch(() => {
            this.errorMessage?.classList.remove('hidden');
            submitBtn?.removeAttribute('disabled');
          });
      }
    }
  );
}
